import React from 'react';
import { useHistory } from 'react-router-dom';
import LandingLayout from 'components/features/LandingLayout';
import './LogoutPage.css';

export default function LogoutPage() {
  const history = useHistory();

  return (
    <LandingLayout>
      <div className="LogoutPage_MainBox">
        <div className="LogoutPage_MainBox_Message">
          <div>You are now logged</div>
          <div> out of IBMS</div>
        </div>
        <div
          className="LogoutPage_MainBox_LogIn"
          onClick={() => {
            history.push('/');
          }}
        >
          <div className="LogoutPage_MainBox_LogIn_Text">Log in</div>
        </div>
      </div>
    </LandingLayout>
  );
}
